module.exports = __webpack_public_path__ + "static/media/Artboard22.6f502801.png";